import { useState } from "react";
import { useInViewport } from "ahooks";

type Params = Parameters<typeof useInViewport>;

export function useInViewportOnce(target: Params[0], options?: Params[1]) {
  const [wasInViewport, setWasInViewport] = useState(false);

  useInViewport(target, {
    ...options,
    callback: (args) => {
      if (args.isIntersecting && !wasInViewport) {
        setWasInViewport(true);
        options?.callback?.(args);
      }
    },
  });
}
